import { useCallback } from 'react';

import { usePostCommunitySubCommentLike } from '@/hooks/react-query/community/like';
import { useDeleteCommunityPostSubComment } from '@/hooks/react-query/community/subComment';
import { sendLog } from '@/lib/utils/send-log';

export function useDeleteSubComment({
  subCommentId,
  postId,
}: {
  subCommentId: string;
  postId: string;
}) {
  const { mutate: deleteSubComment, isPending } =
    useDeleteCommunityPostSubComment({ subCommentId, postId });

  function handleDelete() {
    /**
     * @todo community 이미 삭제되었을 경우 에러 메시지 띄우기
     */
    deleteSubComment({ subCommentId });
  }

  return { handleDelete, isPending };
}

export function useLikeSubComment({
  subCommentId,
  postId,
}: {
  subCommentId: string;
  postId: string;
}) {
  const { mutate: like } = usePostCommunitySubCommentLike({
    postId,
    subCommentId,
  });

  const handleClickLike = useCallback(() => {
    like(
      { subCommentId },
      {
        onSuccess: () => {
          sendLog('hh_community_post_comment_like', {
            post_id: postId,
            comment_id: subCommentId,
            type: '대댓글',
          });
        },
      },
    );
  }, [like, postId, subCommentId]);

  return { handleClickLike };
}
